var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5227 8.34945e-05 20 4.47729 20 10C19.9999 15.5226 15.5226 19.9999 10 20C4.47729 20 8.34969e-05 15.5227 0 10C0 4.47724 4.47724 0 10 0ZM13.3994 7.13184C12.9987 6.68821 12.349 6.68834 11.9482 7.13184L8.40723 11.0537L7.45215 9.99512C7.05149 9.55159 6.4017 9.55175 6.00098 9.99512C5.60023 10.439 5.60023 11.1596 6.00098 11.6035L7.68262 13.4658C7.88238 13.6882 8.14466 13.7988 8.40723 13.7988C8.66877 13.7988 8.93187 13.6884 9.13281 13.4658L13.3984 8.74121C13.8003 8.29606 13.8002 7.57696 13.3994 7.13184Z",
    fill: "#A4D65E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.5c2fa3018f99e0393714c7c5f65304cc.svg";
export { ForwardRef as ReactComponent };